import React from 'react';
import classNames from 'classnames';
import FormPureComponent, { FormPureComponentItem } from '../generic.component.jsx';
import style from './dropdown.less';
import { EMPTY_STRING } from '../../questionnaire.utils.jsx';
import { KEY_CODES } from '../../../common/utils.jsx';

const { ENTER, SPACE, ARROW_DOWN, ARROW_UP, TAB } = KEY_CODES;

export class DropDownItem extends FormPureComponentItem {
    render() {
        const { name, activeItem } = this.props;
        const cssClass = classNames(style.dropdownItemWrapper, { [style.selected]: activeItem === name });
        return (
            <li className={cssClass} onClick={this.onChangeHandler}>
                <a tabIndex="0" className={style.dropdownItem}>
                    <span className={style.itemText}>{name}</span>
                </a>
            </li>
        );
    }
}

export default class DropDown extends FormPureComponent {
    constructor() {
        super();
        this.state = { open: false, selected: null };
        this.closeMenu = this.closeMenu.bind(this);
        this.openMenu = this.openMenu.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.getOptionByValue = this.getOptionByValue.bind(this);
        this.keyPressHandler = this.keyPressHandler.bind(this);

        DropDown.__instances.push(this);
    }

    static bindItemCreator(callback, value) {
        return function itemCreator(item, index) {
            return <DropDownItem key={index} name={item.name} activeItem={value} value={item.value} onChangeCallback={callback}/>;
        };
    }

    componentWillUnmount() {
        const instanceIndex = DropDown.__instances.indexOf(this);
        if (-1 !== instanceIndex) {
            DropDown.__instances.splice(instanceIndex, 1);
        }
    }
    getOptionByValue(value) { return this.props.options.find((item) => item.value === value); }
    keyPressHandler(event) {
        const { options, value, disabled } = this.props;
        const isOpen = this.state.open;
        const keyCode = event.keyCode;
        /*
        * TODO: CHECK WITH EMPTY VALUE
        * */
        if (disabled) { return; }
        if (TAB === keyCode) { return; }
        const LAST_ITEM_INDEX = options.length - 1;
        const optionItem = this.state.selected || this.getOptionByValue(value) || options[0];
        const index = options.findIndex((item) => item.value === optionItem.value);

        let newIndex = null;
        if (ARROW_DOWN === keyCode) {
            newIndex = LAST_ITEM_INDEX > index ? index + 1 : 0;
        } else if (ARROW_UP === keyCode) {
            newIndex = 0 < index ? index - 1 : LAST_ITEM_INDEX;
        }

        if (null !== newIndex) {
            const newOption = options[newIndex];
            if (!isOpen) {
                this.onChangeHandler(newOption.value);
            } else {
                this.setState({ selected: newOption });
            }
            event.preventDefault();
            return;
        }

        if (TAB === keyCode) {
            this.closeMenu(event);
            return;
        }

        if (ENTER === keyCode || SPACE === keyCode) {
            if (isOpen) {
                this.onChangeHandler(optionItem.value);
                this.closeMenu(event);
            } else {
                this.openMenu(event);
            }
            event.preventDefault();
        }
    }
    toggleMenu(event) {
        if (event && event.preventPropagation) { event.preventPropagation(); }
        if (this.props.disabled && !this.state.open) { return; }
        this.setState({ open: !this.state.open });
    }
    static closeAllDropdownMenus() {
        const instances = DropDown.__instances;
        const instancesCount = instances.length;
        let instanceIndex = 0;
        let currentInstance = null;
        for (; instanceIndex < instancesCount; instanceIndex++) {
            currentInstance = instances[instanceIndex];
            if (currentInstance.state.open) {
                currentInstance.closeMenu();
            }
        }
    }
    closeMenu() {
        setTimeout(() => { this.setState({ open: false, selected: null }); }, 0);
    }
    openMenu(event) {
        if (event && event.preventPropagation) { event.preventPropagation(); }
        if (this.props.disabled) { return; }
        this.setState({ open: true });
    }
    render() {
        const { options, placeholder, cssButtonClass, cssClassWrapper, cssDropdownClass, disabled } = this.props;
        const optionItem = this.state.selected || this.getOptionByValue(this.props.value);
        const value = optionItem ? optionItem.name : EMPTY_STRING;
        const dropdownClass = classNames(style.drowdownMenu, cssDropdownClass, { [style.open]: this.state.open });
        const buttonClass = classNames(cssButtonClass, style.button, { [style.selected]: value && EMPTY_STRING !== value, [style.disabled]: disabled });
        return (
            <div className={classNames(style.wrapper, cssClassWrapper)}>
                <button className={buttonClass} onClick={this.toggleMenu} disabled={disabled} onKeyDown={this.keyPressHandler}>
                    <span>{ optionItem ? value : placeholder }</span>
                    &nbsp;
                    <span className={style.caret}></span>
                </button>
                {
                    this.state.open && 0 < options.length
                    ?   <div className={dropdownClass}>
                            <ul className={style.dropdownList}>
                                { options.map(DropDown.bindItemCreator(this.onChangeHandler, value)) }
                            </ul>
                        </div>
                    : null
                }
            </div>
        );
    }
}
DropDown.__instances = [];
document.body.addEventListener('click', DropDown.closeAllDropdownMenus);
